export default __webpack_public_path__ + "static/media/carousel-2.20d1de1d.png";